export const STOREDATA = "STOREDATA";
export const STOREAUTHTOKEN = "STOREAUTHTOKEN";
export const STOREACCOUNTDATA = "STOREACCOUNTDATA";
export const OFFER_DETAILS = "OFFER_DETAILS";
export const BASIC_DETAILS = "BASIC_DETAILS";
export const RESET_CONTEXT = "RESET_CONTEXT"
